module.exports = __webpack_public_path__ + "media/talk-to-sales.f89f8d5d.png";